export default __webpack_public_path__ + "static/media/lamp.41886393.png";